import { makeHTTPProvider } from 'shared/infra/providers';

export async function fetchPaymentMethods(type, tenancia) {
  return makeHTTPProvider()
    .get(`/paymentmethods?tenancia=${tenancia}`)
    .then(res => {
      return res.filter(d => d.tipo === type);
    });
}

export function defaultPaymentMethodFor(paymentType, methods) {
  return methods
    .sort(
      (a, b) =>
        b.numeroMaximoParcelas - a.numeroMaximoParcelas ||
        a.valorMinimoParcela - b.valorMinimoParcela,
    )
    .filter(method => method.formaPagamento === paymentType)
    .shift();
}

export async function fetchCreatePaymentPix(idBudget, dadosAssinaturaDigital) {
  const body = {
    idOrcamento: idBudget,
    cupom: '',
    dadosAssinaturaDigital,
  };

  return makeHTTPProvider()
    .post(`/pix/criarCobranca`, body)
    .then(data => {
      const { linhaDigitavel, dataVencimento } = data;

      return {
        linhaDigitavel,
        dataVencimento,
      };
    });
}

export function fetchBudgetPaymentStatus(idBudget) {
  return makeHTTPProvider()
    .get(`/orcamentos/${idBudget}/status`)
    .then(data => {
      const { value } = data;

      return {
        value,
      };
    });
}

export async function createNupayPayment(idBudget, dadosAssinaturaDigital) {
  const body = {
    idOrcamento: idBudget,
    cupom: '',
    dadosAssinaturaDigital,
  };

  return makeHTTPProvider()
    .post(`/nupay/criarPagamento`, body)
    .then(data => {
      const { paymentUrl, dataVencimento } = data;

      return {
        paymentUrl,
        dataVencimento,
      };
    });
}
